import { useState, ReactNode, useRef } from 'react'
import cl from 'classnames'

import styles from './styles.module.scss'
import IconArrowCircle from '@assets/arrow-circle.svg'

interface CollapsibleItemArrowRightProps {
  question?: string
  children?: ReactNode
  className?: string
  customQuestionComponent?: ReactNode
}

export const CollapsibleItemArrowRight = ({
  question,
  children,
  className
}: CollapsibleItemArrowRightProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const parentRef = useRef<HTMLDivElement>()

  return (
    <li className={className}>
      <div className={cl({ 'flex flex-col': isOpen })}>
        <div
          className={cl(
            styles.headerQuestion,
            isOpen
              ? 'rounded-bl-none rounded-br-none'
              : 'rounded-bl-lg rounded-br-lg'
          )}
          onClick={() => setIsOpen(!isOpen)}
        >
          <h3
            className={cl(
              styles.questionText,
              isOpen ? 'font-semibold' : 'font-normal'
            )}
          >
            {question}
          </h3>
          <IconArrowCircle className={cl({ 'transform rotate-90': isOpen })} />
        </div>
        <div
          className={styles.wrapperContent}
          ref={parentRef}
          style={{
            height: isOpen ? parentRef?.current?.scrollHeight + 'px' : '0px'
          }}
        >
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </li>
  )
}
